module.exports = __webpack_public_path__ + "img/icon-ohjeet-white.acb03e89.svg";